<template>
  <div class="as-match-list">
    <MatchItem
      v-for="(item, key) in rows"
      :key="key"
      :match="parseMatchH2hData(item, homeTeamId)"
      :teams="teams"
      :competitions="competitions"
      :isShowFooter="isShowFooter"
      :isH2h="true"
    />

    <div v-if="!isShowMore" @click="isShowMore = true" class="as-show-more">
      Hiển thị thêm trận đấu <ArrowDown />
    </div>
  </div>
</template>
<script setup lang="ts">
import { defineProps, computed, ref } from "vue";
import type { IMatch, ITeam, ILeague } from "~src/interfaces/basketball";
import { parseMatchH2hData } from "~src/helpers/basketball";
import ArrowDown from "~src/components/icons/ArrowDown.vue";
import MatchItem from "~src/components/matches/basketball/MatchItem.vue";

interface IProps {
  h2h: Array<Object>;
  teams: Array<ITeam>;
  competitions: Array<ILeague>;
  match: IMatch;
  tab: string;
  isShowFooter: boolean;
  homeTeamId: string;
}

const props = withDefaults(defineProps<IProps>(), {
  isShowFooter: true
});

const isShowMore = ref(props.h2h?.length > 5 ? false : true);

const rows = computed(() => {
  if (isShowMore.value) {
    return props.h2h;
  }

  return props.h2h?.slice(0, 5);
});
</script>

<script lang="ts">
export default {};
</script>
